<template>
  <div class="systemSettlementCurrency">
    <span>结算币种：</span>
    <p>{{currency}}</p>
  </div>
</template>

<script>
  export default {
    name: 'systemSettlementCurrency',
    data() {
      return {
        currency: '越南盾'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .systemSettlementCurrency{
    margin: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span{
      margin-right: 5px;
      font-size: 16px;
    }
    p{
      font-size: 18px;
      font-weight: bolder;
      color: #409eff;
    }
  }
</style>
